module.exports = __webpack_public_path__ + "static/media/boxes.b2fda81c.svg";